module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_6000.ae10c8f4.png";